import { render, staticRenderFns } from "./comp-schedule.vue?vue&type=template&id=48cf3652&scoped=true&"
import script from "./comp-schedule.vue?vue&type=script&lang=js&"
export * from "./comp-schedule.vue?vue&type=script&lang=js&"
import style0 from "./comp-schedule.vue?vue&type=style&index=0&id=48cf3652&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf3652",
  null
  
)

export default component.exports